<template>
    <span class="fa-stack fa-lg mailed-stack cursor-pointer pt-1 mr-1" title="Submitted by Mail" data-toggle="popover" data-html="true" data-placement="top" :data-content="getMailedDates()">
        <i class="fas fa-envelope-open-text fa-stack-2x mailed-icon text-primary"></i>
        <i :class="[receivedDate ? 'fas' : 'far', 'fa-check-circle fa-stack-1x text-success mailed-badge']"></i>
    </span>   
</template>

<script>
export default {
    props: {
        mailedDate: String,
        receivedDate: String
    },
    methods: {
        getMailedDates: function () {
            return 'Mailed Date: ' + (this.mailedDate ? this.mailedDate : 'not set') + '<br />' +
                'Received Date: ' + (this.receivedDate ? this.receivedDate : 'not set');
        }
    }   
}
</script>

<style scoped>
    .mailed-stack {
        width: 1em;
        height: 1em;
        line-height: 1em;
        vertical-align: 0%;
    }

    .mailed-icon {
        font-size: 1em;
    }
    
    .mailed-badge {
        font-size: .6em;
        position: relative;
        top: -12px;
        left: 10px;
    }
</style>